export default __webpack_public_path__ + "58f8987329678cc461270e2c13cbb4ef.png";